import i18n from '~/locales/i18n';

i18n.addResourceBundle('en', 'app', {
  age: 'Age',
  gender: 'Gender',
  maritalStatus: 'Marital Status',
  education: 'Education',
  industry: 'Industry',
  position: 'Position',
  purchaseInfo: 'Purpose of Purchasing',
});
